import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import PageBase from 'components/PageBase';
import {
  AppBar,
  TextField,
  MenuItem,
  Button,
  Grid,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import {
  LEAD_TYPES,
  LEAD_STATUSES,
  LEAD_EXTERNAL_STATUSES,
} from 'config';
import * as API from 'services/api';
import { StyledTabs, StyledTab } from 'components/CustomTab'
import SearchIcon from '@material-ui/icons/Search';

import DetailsModal from './message'
import FormDetails from './components/FormDetails'
import moment from 'moment';
import useStyles from '../styles';
import useHomeContext from 'layouts/HomeLayout/context';
import { columnCreatedAt, columnId, columnActions, filterTableData } from 'pages/common';
import ActionGroup from 'components/ActionGroup';
import { PERPAGE } from 'config';
import ExportCSV from 'components/ExportCSV';
import DataTable from 'components/PageBase/dataTable';
import { ReactComponent as IconFilter } from 'assets/svgs/product_filter.svg';

let page = 1;

const Contacts = ({ intl: { formatMessage } }) => {

  const classes = useStyles();

  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  // const [usersLoading, setUsersLoading] = useState(true);
  const [allUsersLoaded, setAllUsersLoaded] = useState(false);
  const [exportType, setExportType] = useState();

  const [loading, setLoading] = useState(true);
  const [pageState, setPageState] = useState(1);
  const [total, setTotal] = useState(0);
  const [openFilter, setOpenFilter] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [companyInput, setCompanyInput] = useState('');
  const [siretInput, setSiretInput] = useState('');
  const [filtersObj, setFiltersObj] = useState({});

  const [openModal, setOpenModal] = useState(false);
  const [detail_Id, setDetailId] = useState(null);

  const [openFormModal, setOpenFormModal] = useState();
  const [companies, setCompanies] = useState([]);

  const [teams, setTeams] = useState([]);
  const [tab, setTab] = useState("all");

  const [initLoad, setInitLoad] = useState(false);
  const { onDeleteById } = useHomeContext();

  const handleTabChange = (event, newValue) => {
    setInitLoad(false)
    setTab(newValue)
  };

  useEffect(() => {
    loadRecords(true);
  }, [tab]);
  useEffect(() => {
    loadRecords(true);
  }, [keyword]);
  useEffect(() => {
    API.listClients()
      .then(res => {
        if (res.code === 200) {
          setCompanies(res.data.filter(el => el.company).sort((a, b) => a.company.trim().localeCompare(b.company.trim())))
        }
      })
    API.listTeams({})
      .then(res => {
        if (res.code === 200) {
          setTeams(res.data);
        }
      })
      .catch(err => {

      });
  }, []);

  const loadRecords = (init, requestedPage) => {
    setLoading(true);
    // setUsersLoading(true);
    const pageToLoad = requestedPage || (init ? 1 : (pageState || 1));
    if (init) {
      setUsers([]);
      setAllUsersLoaded(false);
      setPageState(1);
    }

    API.listLeads({
      page: pageToLoad,
      perPage: PERPAGE,
      ...tab != 'all' ? { type: tab } : {},
      ...keyword && keyword.trim().length > 0 ? { keyword: keyword.trim() } : {},
      ...filtersObj
    }).then(res => {
      if (!initLoad) setInitLoad(true)
      let news = res.data.map(el => mapData(el));
      setUsers(news);
      setTotal(res.total || 0);
      setPageState(pageToLoad);
      setAllUsersLoaded(res.data.length < PERPAGE);
      setLoading(false);
      // setUsersLoading(false);
    })
      .catch(err => {
        setLoading(false);
        // setUsersLoading(false);
      });
  };

  const mapData = (el) => {
    const result = { ...el };
    if (!el.userId) {
      result.owner_name = `${el.source?.firstName || ""} ${el.source?.lastName || ""}`
    }

    result.typeName = tab == "gcorder" ? formatMessage({ id: `lead.type.gcorder` }) : formatMessage({ id: `lead.type.${el.type}` });
    switch (el?.type) {
      case "hubspotform":
        result.sourceContent = el.name;
        break;
      case LEAD_TYPES[0]: //'hubspot'
        result.sourceContent = `Ticket: ${el.source?.title || ""}`
        break;
      case LEAD_TYPES[1]: //'chat'
        result.sourceContent = (el.source?.description || "")
        break;
      case LEAD_TYPES[2]: //'userspaces'
        result.sourceContent = el.source?.productType == 'pack' ? formatMessage({ id: `home.catalogue.field.catalogueType.` + el.source?.productType }) : `Commande ${el.source?.title}`
        break;
      case LEAD_TYPES[3]: //'guestspaces'
        result.sourceContent = el.source?.productType == 'pack' ? formatMessage({ id: `home.catalogue.field.catalogueType.` + el.source?.productType }) : `Commande ${el.source?.title}`
        break;
      default:
        result.sourceContent = ""
        break;
    }

    if (tab == "userspaces" || tab == "gcorder") {
      try {
        const source = JSON.parse(el.source.data);
        result.training_center_name = source.training_center_name
        result.typeProduit = el.source.productType == "pack" ? "PACK" : (source.typeProduit || "").toUpperCase()
      } catch (err) {
        console.log("parse error:", err)
        return el
      }
    }
    return result
  }
  // const loadMore = () => {
  //   console.log("loadMore!!!");
  //   if (allUsersLoaded || usersLoading || !initLoad) {
  //     return;
  //   }
  //   setUsersLoading(true);
  //   setTimeout(() => {
  //     loadRecords();
  //   }, 500)
  // };

  const handlePageChange = (newPage) => {
    if (newPage === pageState) return;
    loadRecords(false, newPage);
  }

  const loadExportData = (_page, exportMode) => {
    setLoading(true);
    API.listLeads({
      page: _page || 1,
      perPage: 100,
      ...tab != 'all' ? { type: tab } : {},
      ...keyword && keyword.trim().length > 0 ? { keyword: keyword.trim() } : {},
    }).then(res => {
      if (res.code === 200) {
        let newUsers = res.data.map(el => mapData(el))

        setData(prev => [...prev, ...newUsers]);
        if (newUsers.length < 100) {
          setLoading(false);
          setExportType(exportMode);
        } else {
          loadExportData(_page + 1, exportMode);
        }
      }
    });
  };
  const updateField = (e, id, fieldName, payload) => {
    const newValue = e.target.value;
    API.updateLead(id, payload ?? { [fieldName]: newValue }).then(res => {
      if (res.code === 200) {
        setUsers(prev => prev.map(item => item.id == id ? { ...item, [fieldName]: newValue } : item));
      }
    }).catch(() => {});
  }

  const tableColumns = tab == "intra" ? [
    columnId(formatMessage),
    {
      name: 'source.title',
      label: "Titre de la formation",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'source.traineeCount',
      label: "Nombre de stagiaire",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'source.orderDate',
      label: "Date souhaité",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return moment(value).format("DD/MM/YYYY")
        },
      },
    },
    columnCreatedAt(formatMessage),
    columnActions((value, tableMeta, updateValue) => renderIntraAction(tableMeta, users))
  ] : [
    columnId(formatMessage),
    {
      name: 'typeName',
      label: "Type",
      options: {
        filter: false,
        sort: true,
      },
    },
    ...(tab != "userspaces" && tab != "gcorder") && [
      {
        name: 'owner_name',
        label: formatMessage({
          id: 'user',
        }),
        options: {
          filter: true,
          sort: true
        },
      },
      {
        name: 'teamIds',
        label: formatMessage({
          id: 'navbar.users.internal.teams',
        }),
        options: {
          filter: false,
          sort: false,
          customBodyRender: value => {
            return value?.length > 0 ? value.map(item => teams.find(el => el.id == item)).filter(item => item).map(item => item.title).join(', ') : ''
          }
        },
      },
    ] || [],
    ...(tab == "userspaces" || tab == "gcorder") && [
      {
        name: 'owner_name',
        label: formatMessage({
          id: 'user',
        }),
        options: {
          filter: true,
          sort: true,
        },
      },
      ...tab == "gcorder" && [
        {
          name: 'client',
          label: formatMessage({
            id: 'company',
          }),
        }
      ] || [
        {
          name: 'typeProduit',
          label: formatMessage({
            id: 'leads.table.producttype',
          }),
          options: {
            filter: true,
            sort: true,
          },
        },
        {
          name: 'training_center_name',
          label: formatMessage({
            id: 'leads.table.trainingcenter',
          }),
          options: {
            filter: false,
            sort: true,
          },
        }]
    ] || [],
    {
      name: 'sourceContent',
      label: "Source",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'status',
      label: formatMessage({
        id: 'statusInternal',
      }),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => renderStatusInternal(value, tableMeta, updateField)
      },
    },
    {
      name: 'statusExternal',
      label: formatMessage({
        id: 'statusExternal',
      }),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => renderStatusExternal(value, tableMeta, updateField)
      },
    },
    {
      name: 'reference',
      label: formatMessage({
        id: 'leads.table.reference',
      }),
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => renderRefenece(value, tableMeta, updateField)
      }
    },
    columnCreatedAt(formatMessage),
    columnActions(
      (value, tableMeta, updateValue) => renderActions(tableMeta, users)
    )
  ];
  const renderIntraAction = useCallback((tableMeta, users) => {
    const record = users.find(item => item.id == tableMeta.rowData[0])
    return (<ActionGroup
      onView={() => {
        setOpenFormModal(record)
      }}
      onDelete={() => {
        onDeleteById(tableMeta.rowData[0], "deleteLead", () => {
          loadRecords(true)
        });
      }}
    >
    </ActionGroup>
    )
  }, [tab])
  const renderRefenece = useCallback((value, tableMeta, updateField) => {
    return <TextField
      select
      variant="outlined"
      value={value}
      onChange={e => {
        updateField(e, tableMeta.rowData[0], "reference")
      }}
      style={{ minWidth: 160 }}
    >
      {
        ["bb", "pk", "cv"].map(item => {
          return <MenuItem key={item} value={item}>
            {formatMessage({ id: 'leads.table.reference.' + item })}
          </MenuItem>
        })
      }
    </TextField>
  }, [])
  const renderStatusInternal = useCallback((value, tableMeta, updateField) => {
    return <TextField
      select
      variant="outlined"
      value={value}
      onChange={e => {
        updateField(e, tableMeta.rowData[0], "status", { status: e.target.value })
      }}
      style={{ minWidth: 160 }}
    >
      {
        LEAD_STATUSES.map(item => {
          return <MenuItem key={item} value={item}>
            {formatMessage({ id: 'leads.status.' + item })}
          </MenuItem>
        })
      }
    </TextField>
  }, [])
  const renderStatusExternal = useCallback((value, tableMeta, updateField) => {
    return <TextField
      select
      variant="outlined"
      value={value || LEAD_EXTERNAL_STATUSES[0]}
      onChange={e => {
        updateField(e, tableMeta.rowData[0], "statusExternal")
      }}
      style={{ minWidth: 160 }}
    >
      {
        LEAD_EXTERNAL_STATUSES.map(item => {
          return <MenuItem key={item} value={item}>
            {formatMessage({ id: 'leads.status.' + item })}
          </MenuItem>
        })
      }
    </TextField>
  }, [])
  const renderActions = useCallback((tableMeta, users) => {
    const record = users.find(item => item.id == tableMeta.rowData[0])
    return (<ActionGroup
      onReply={record?.type == LEAD_TYPES[1] ? () => {
        setDetailId(record);
        setOpenModal(true)
      } : null}
      onDelete={() => {
        onDeleteById(tableMeta.rowData[0], "deleteLead", () => {
          loadRecords(true)
        });
      }}
      onView={record?.type != LEAD_TYPES[1] ? () => {
        setOpenFormModal(record)
      } : null}
    >
    </ActionGroup>
    )
  }, [tab])
  const excelData = data.map(user => {
    const company = user.clientId && companies.find(e => e.id == user.clientId);
    return {
      ...user,
      type: formatMessage({ id: 'lead.type.' + user.type }),
      status: formatMessage({ id: 'leads.status.' + user.status }),
      statusExternal: formatMessage({ id: 'leads.status.' + user.statusExternal }),
      ...tab == "intra" ? {
        title: user.source.title,
        traineeCount: user.source.traineeCount,
        orderDate: moment(user.source.orderDate).format("DD/MM/YYYY")
      } : {},
      client: company?.company
    }
  });
  const headers = tab == "intra" && [
    { label: formatMessage({ id: 'no' }), key: 'id' },
    { label: "Titre de la formation", key: 'title' },
    { label: "Nombre de stagiaire", key: 'traineeCount' },
    { label: "Date souhaité", key: 'orderDate' },
    {
      key: 'createdAt',
      label: formatMessage({
        id: 'created_at',
      })
    }
  ] || [
      { label: formatMessage({ id: 'no' }), key: 'id' },
      { label: "Type", key: 'typeName' },
      ...(tab != "userspaces" && tab != "gcorder") ? [
        {
          key: 'owner_name',
          label: formatMessage({
            id: 'user',
          }),
        },
        {
          key: 'teamIds',
          label: formatMessage({
            id: 'navbar.users.internal.teams',
          }),
        },
      ] : [],
      ...(tab == "userspaces" || tab == "gcorder") && [
        {
          key: 'owner_name',
          label: formatMessage({
            id: 'user',
          }),
        },
        ...tab == "gcorder" && [
          {
            key: 'client',
            label: formatMessage({
              id: 'company',
            }),
          }
        ] || [
          {
            key: 'typeProduit',
            label: formatMessage({
              id: 'leads.table.producttype',
            }),
          },
          {
            key: 'training_center_name',
            label: formatMessage({
              id: 'leads.table.trainingcenter',
            }),
          }
        ]
      ] || [],
      {
        key: 'sourceContent',
        label: "Source",
      },
      [
        {
          key: 'status',
          label: formatMessage({
            id: 'statusInternal',
          })
        },
      ],
      {
        key: 'statusExternal',
        label: formatMessage({
          id: 'statusExternal',
        }),
      },
      {
        key: 'createdAt',
        label: formatMessage({
          id: 'created_at',
        })
      }
    ];

  let datasource = tab == "gcorder" ? users.map(el => {
    const company = companies.find(e => e.id == el.clientId);
    return {
      ...el,
      client: company?.company
    }
  }) : users

  return (
    <PageBase title={formatMessage({ id: 'home.contacts.title' })}
      rightComponent={<div className={classes.rightdom}>
        <ExportCSV
          filename="leads"
          headers={headers}
          data={excelData}
          loadExportData={loadExportData}
          exportType={exportType}
          setExportType={setExportType}
        />
      </div>}
      loading={loading}
    >
      <AppBar position="static" className={classes.appbar}>
        <StyledTabs value={tab} onChange={handleTabChange} aria-label="services tabs" className={classes.tabsContainer}>
          <StyledTab key="all" value="all" className={classes.tabContainer} label={<FormattedMessage id="lead.type.all" />} />
          <StyledTab key="chat" value="chat" className={classes.tabContainer} label={<FormattedMessage id={"lead.type.chat"} />} />
          <StyledTab key="userspaces" value="userspaces" className={classes.tabContainer} label={<FormattedMessage id={"lead.type.userspaces"} />} />
          <StyledTab key="gcorder" value="gcorder" className={classes.tabContainer} label={<FormattedMessage id={"lead.type.gcorder"} />} />
          <StyledTab key="question" value="question" className={classes.tabContainer} label={<FormattedMessage id={"lead.type.question"} />} />
          <StyledTab key="intra" value="intra" className={classes.tabContainer} label={<FormattedMessage id={"Demande Intra"} />} />
        </StyledTabs >
      </AppBar>
      <DataTable
        dataLoading={loading}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        setFilters={() => { }}
        rightComponent={<div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <Button className={classes.filterBtn} startIcon={<SearchIcon className={classes.filterIcon} />} variant="outlined" size="small" onClick={() => setOpenFilterDialog(true)}>{formatMessage({ id: 'table.filter.button' })}</Button>
        </div>}
        keyword={keyword}
        setKeyword={setKeyword}
        // use pagination instead of Load More
        allUsersLoaded={allUsersLoaded}
        pagination={{ page: pageState, perPage: PERPAGE, total, onChange: handlePageChange }}
        tableColumns={tableColumns}
        datasource={datasource}
        data={users}
      />

      <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{formatMessage({ id: 'home.users.leads.title' })}</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', gap: 12, flexDirection: 'column' }}>
            <TextField label="Dénomination sociale" variant="outlined" value={companyInput} onChange={e => setCompanyInput(e.target.value)} />
            <TextField label="SIRET" variant="outlined" value={siretInput} onChange={e => setSiretInput(e.target.value)} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setCompanyInput('');
            setSiretInput('');
            setFiltersObj({});
            setOpenFilterDialog(false);
            const newFilters = {};
            setLoading(true);
            // setUsersLoading(true);
            setUsers([]);
            setAllUsersLoaded(false);
            setPageState(1);

            API.listLeads({
              page: 1,
              perPage: PERPAGE,
              ...tab != 'all' ? { type: tab } : {},
              ...newFilters
            }).then(res => {
              if (!initLoad) setInitLoad(true)
              let news = res.data.map(el => mapData(el));
              setUsers(news);
              setTotal(res.total || 0);
              setPageState(1);
              setAllUsersLoaded(res.data.length < PERPAGE);
              setLoading(false);
              // setUsersLoading(false);
            })
              .catch(err => {
                setLoading(false);
                // setUsersLoading(false);
              });
          }}>{formatMessage({ id: 'home.users.filter.clear' })}</Button>
          <Button onClick={() => setOpenFilterDialog(false)}>{formatMessage({ id: 'home.users.filter.cancel' })}</Button>
          <Button color="primary" variant="contained" onClick={() => {
            const newFilters = {};
            if (companyInput && companyInput.trim().length > 0) newFilters.company = companyInput.trim();
            if (siretInput && siretInput.trim().length > 0) newFilters.siret = siretInput.trim();
            
            setLoading(true);
            // setUsersLoading(true);
            
            // Search all leads matching filters across entire collection
            API.searchLeads({
              page: 1,
              perPage: PERPAGE,
              ...tab != 'all' ? { type: tab } : {},
              ...newFilters
            }).then(res => {
              if (!initLoad) setInitLoad(true);
              let news = res.data ? res.data.map(el => mapData(el)) : [];
              setUsers(news);
              setTotal(res.total || 0);
              setPageState(1);
              setAllUsersLoaded(news.length < PERPAGE);
              setFiltersObj(newFilters);
              setOpenFilterDialog(false);
              setLoading(false);
              // setUsersLoading(false);
            }).catch(err => {
              setLoading(false);
              // setUsersLoading(false);
              setOpenFilterDialog(false);
            });
          }}>{formatMessage({ id: 'home.users.filter.apply' })}</Button>
        </DialogActions>
      </Dialog>
      
      <DetailsModal
        formatMessage={formatMessage}
        requestId={detail_Id}
        open={openModal}
        handleClose={(refresh) => {
          setOpenModal(false)
        }}
      />
      {
        openFormModal &&
        <FormDetails
          formatMessage={formatMessage}
          data={openFormModal}
          open={!!openFormModal}
          handleClose={(refresh) => {
            setOpenFormModal()
          }}
          companies={companies}
        />
      }
    </PageBase>
  );
};

Contacts.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default injectIntl(Contacts);
